module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }